import React from 'react';
import { Button } from 'formlabs-web-components/Link';

const ButtonPlugin = ({ buttonText, arrow, color, url, to }) => (
  <Button {...{ arrow, color, url, to }}>{buttonText}</Button>
);

export default ButtonPlugin;
